//一些不用后端控制的权限 比如星广汇链接跳转不用控制。
export const staticPermissions = [
]
